import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ArrowLeft2, ArrowRight2 } from "iconsax-reactjs";
import ProfileCard from "../Card/ProfileCard";
import { motion, Variants } from "framer-motion";
import teamMember1 from "../../assets/team.jpg";
import teamMember2 from "../../assets/team-2.jpg";
import teamMember3 from "../../assets/team-3.jpg";
import teamMember4 from "../../assets/team-4.jpg";

function Team() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const teamMembers = [
    {
      name: "Thomas W/yesus",
      title: "General Manager",
      desc: "",
      image: teamMember4,
    },
    {
      name: "Bezawit Girma",
      title: "Marketing Manager",
      desc: "",
      image: teamMember2,
    },
    {
      name: "Wengel Bizuayew",
      title: "Finanace Officer",
      desc: "",
      image: teamMember1,
    },
    {
      name: "Abel W/yesus",
      title: "Sales Manager",
      desc: "",
      image: teamMember3,
    },
  ];

  // Framer Motion Variants
  const containerVariants: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.15 } },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <motion.div
      id="Team"
      className="bg-white pt-48 pb-36"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: "some" }}
      variants={containerVariants}
    >
      {/* Header & Controls */}
      <motion.div
        className="flex flex-col sm:flex-row justify-between sm:items-end mb-24 px-10 sm:px-20 lg:px-32"
        variants={itemVariants}
      >
        <div>
          <div className="inter-black text-2xl mb-3.5 text-[#EEB762]">
            MANAGEMENT
          </div>
          <h3 className="text-[#1F1F1E] changa-one-regular text-4xl sm:text-6xl">
            OUR <br />
            DIRECTORS
          </h3>
        </div>
        <div className="flex gap-[16px] mt-10 sm:mt-0">
          <button
            ref={prevRef}
            disabled={isBeginning}
            className={`h-[56px] w-[56px] rounded-full flex justify-center items-center transition-opacity ${
              isBeginning
                ? "opacity-40 cursor-not-allowed bg-[#D9D9D9] border-[2px] border-[#D9D9D9]"
                : "opacity-100 border-[2px] border-[#EEB762]"
            }`}
          >
            <ArrowLeft2 size="24" color={isBeginning ? "#fff" : "#EEB762"} />
          </button>
          <button
            ref={nextRef}
            disabled={isEnd}
            className={`h-[56px] w-[56px] rounded-full flex justify-center items-center transition-opacity ${
              isEnd
                ? "opacity-40 cursor-not-allowed bg-[#D9D9D9] border-[2px] border-[#D9D9D9]"
                : "opacity-100 border-[2px] border-[#EEB762]"
            }`}
          >
            <ArrowRight2 size="24" color={isEnd ? "#fff" : "#EEB762"} />
          </button>
        </div>
      </motion.div>

      {/* Swiper */}
      <div className="px-10 sm:px-20 lg:px-32">
        <Swiper
          modules={[Navigation]}
          spaceBetween={30}
          slidesPerView={"auto"}
          onInit={(swiper: any) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          onSlideChange={(swiper: any) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
        >
          {teamMembers.map((member, idx) => (
            <SwiperSlide key={idx} className="!w-[300px] max-w-full">
              <motion.div variants={itemVariants}>
                <ProfileCard
                  name={member.name}
                  title={member.title}
                  desc={member.desc}
                  image={member.image}
                />
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </motion.div>
  );
}

export default Team;
